import InputText from "./InputText";
import PopOverCalendar from "./PopOverCalendar";
import React, { Component } from 'react';
import moment from 'moment-timezone';

class CalendarInputWithButton extends Component {
	state = {
		'currentDate': '',
		'hasErrorMsg': false
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.hasOwnProperty('value') && this.state.currentDate !== nextProps.value) {
			this.setDate(nextProps.value);
		}
	}

	render() {
		const { disabled, value } = this.props;
		let calendarValue = '';
		if (this.state.currentDate === '') {
			calendarValue = null;
		} else {
			calendarValue = moment(this.state.currentDate, 'M/D/YY').toDate();
		}
		return <div className='input_and_calendar'>
			<InputText
				onChange={this.setDate}
				placeholder={value}
				value={this.state.currentDate}
				//onBlur = { this.verifyDate }
				disabled={disabled}
			/>
			{this.errorMsg()}
			<PopOverCalendar
				onChange={this.setDateFromSelector}
				value={calendarValue}
				locale={moment.tz.guess()}
				disabled={disabled}
			/>
		</div>
	}

	errorMsg = () => {
		return this.state.hasErrorMsg === true ? <span>Date Format Not Recognized</span> : null;
	}

	setDate = (value) => {
		this.setState((prevState) => {
			if (prevState.currentDate === value) {
				return {};
			}
			return {
				currentDate: value,
				hasErrorMsg: false
			}
		})
	}

	verifyDate = () => {
		const { currentDate } = this.state;
		if (currentDate === '') {
			return this.onChange(currentDate);
		}
		const baseDate = moment(currentDate, 'M/D/YY')
		if (baseDate.isValid() === false) {
			return this.setState({
				hasErrorMsg: true
			});
		}
		const newDate = baseDate.format('MM/DD/YY');
		this.onChange(newDate);
	}

	setDateFromSelector = (value) => {
		const newDate = moment(value, 'M/D/YY').format('MM/DD/YY');
		this.onChange(newDate);
	}

	onChange = (value) => {
		const { returnObj, onChange } = this.props;
		this.setDate(value);
		onChange(value, returnObj);
	}
}

CalendarInputWithButton.defaultProps = {
	disabled: false
}

export default CalendarInputWithButton;


// WEBPACK FOOTER //
// ./src/components/blueprintWrappers/CalendarInputWithButton.js